import Iconify from 'src/components/Iconify';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'src/@/components/ui/card';
import { Label } from 'src/@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import { Textarea } from 'src/@/components/ui/textarea';

const ASSINATURA_OPCOES = [
    { value: 'digital', label: 'Digital' },
    { value: 'fisico', label: 'Físico' },
    { value: 'ambos', label: 'Ambos' },
];

const CHAVES_OPCOES = [
    { value: 'imobiliaria', label: 'Na imobiliária' },
    { value: 'proprietario', label: 'Com o proprietário' },
    { value: 'porteiro', label: 'Com o porteiro' },
    { value: 'lockbox', label: 'Lockbox' },
];

const LABEL_CLS = 'text-xs font-semibold uppercase tracking-wider text-gray-500';
const INPUT_CLS = 'rounded-xl border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20';

export default function PoliticasSection({ aiAgent, changeModuleConfig }) {
    const politicas = aiAgent?.config?.module?.realstate?.politicas || {};

    const updatePoliticas = (patch) => {
        changeModuleConfig({
            politicas: {
                ...politicas,
                ...patch,
            },
        });
    };

    return (
        <Card className="rounded-xl border border-gray-100 bg-white">
            <CardHeader>
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50">
                        <Iconify icon="mdi:file-document-outline" width={20} className="text-violet-600" />
                    </div>
                    <div>
                        <CardTitle>Políticas</CardTitle>
                        <CardDescription>Regras de assinatura, chaves para visita e detalhes que a Lais deve informar ao cliente.</CardDescription>
                    </div>
                </div>
            </CardHeader>
            <CardContent className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <Label className={LABEL_CLS}>Assinatura de contrato</Label>
                    <Select
                        value={politicas.assinaturaContrato || ''}
                        onValueChange={(value) => updatePoliticas({ assinaturaContrato: value })}
                    >
                        <SelectTrigger className={INPUT_CLS}>
                            <SelectValue placeholder="Selecione" />
                        </SelectTrigger>
                        <SelectContent>
                            {ASSINATURA_OPCOES.map((o) => (
                                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>

                <div className="flex flex-col gap-2">
                    <Label className={LABEL_CLS}>Chaves para visita</Label>
                    <Select
                        value={politicas.chavesVisita || ''}
                        onValueChange={(value) => updatePoliticas({ chavesVisita: value })}
                    >
                        <SelectTrigger className={INPUT_CLS}>
                            <SelectValue placeholder="Selecione" />
                        </SelectTrigger>
                        <SelectContent>
                            {CHAVES_OPCOES.map((o) => (
                                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>

                <div className="flex flex-col gap-2">
                    <Label className={LABEL_CLS}>Detalhes adicionais sobre visitas/contrato</Label>
                    <Textarea
                        value={politicas.detalhesAdicionais || ''}
                        onChange={(e) => updatePoliticas({ detalhesAdicionais: e.target.value })}
                        className={INPUT_CLS}
                        rows={4}
                    />
                </div>
            </CardContent>
        </Card>
    );
}
